import { render, staticRenderFns } from "./UserOptions.vue?vue&type=template&id=0e3481b5&scoped=true&"
import script from "./UserOptions.vue?vue&type=script&lang=js&"
export * from "./UserOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3481b5",
  null
  
)

export default component.exports